import type { ReactNode } from "react";
import { Subscribe, type RowData } from "@tanstack/react-table";
import type { ViewTableRow } from "./core/table";

interface RowExpansionProps<TData extends RowData> {
    row: ViewTableRow<TData>;
    children: (isExpanded: boolean) => ReactNode;
}

/** Renders `children` with whether `row` is expanded; `row` stays the same object while it expands, so the selector re-reads it on every `expanded` change. */
export const RowExpansion = <TData extends RowData>({
    row,
    children,
}: RowExpansionProps<TData>) => (
    <Subscribe
        source={row.table.atoms.expanded}
        selector={() => row.getIsExpanded()}
    >
        {children}
    </Subscribe>
);
RowExpansion.displayName = "RowExpansion";
